import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../app/i18n";
import { RankingPage } from "../areas/public/ranking/RankingPage";
import { isMonthKey } from "../areas/public/ranking/rankingMonths";

export interface RankingSearch {
  month?: string;
}

/** Public monthly ranking (FE-15 §5.2): no session; `?month=YYYY-MM` defaults to the current month. */
export const Route = createFileRoute("/ranking")({
  validateSearch: (search: Record<string, unknown>): RankingSearch => ({
    month: isMonthKey(search.month) ? search.month : undefined,
  }),
  beforeLoad: () => loadNamespaces("public"),
  component: RankingRoute,
});

function RankingRoute() {
  const { month } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <RankingPage
      month={month}
      onMonthChange={(next) =>
        void navigate({ search: next ? { month: next } : {}, replace: true })
      }
    />
  );
}
